/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ apiId: NonNullable<unknown> }} Platform_Not_Found_SiteInputs */

const en_platform_not_found_site = /** @type {((inputs: Platform_Not_Found_SiteInputs) => LocalizedString) & { parts: (inputs: Platform_Not_Found_SiteInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Platform_Not_Found_SiteInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`We couldn’t find an API for “${i?.apiId}”. Back to catalog`)
		}),
		{
			parts: /** @type {(inputs: Platform_Not_Found_SiteInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "We couldn’t find an API for “" }, { type: "text", value: String(i?.apiId) }, { type: "text", value: "”. " }, { type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "text", value: "Back to catalog" }, { type: "markup-end", name: "link", options: {}, attributes: {} }])
			})
		}
	)
);

const zh_hans1_platform_not_found_site = /** @type {((inputs: Platform_Not_Found_SiteInputs) => LocalizedString) & { parts: (inputs: Platform_Not_Found_SiteInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Platform_Not_Found_SiteInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`找不到“${i?.apiId}”对应的 API。返回目录`)
		}),
		{
			parts: /** @type {(inputs: Platform_Not_Found_SiteInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "找不到“" }, { type: "text", value: String(i?.apiId) }, { type: "text", value: "”对应的 API。" }, { type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "text", value: "返回目录" }, { type: "markup-end", name: "link", options: {}, attributes: {} }])
			})
		}
	)
);

const pt_br2_platform_not_found_site = /** @type {((inputs: Platform_Not_Found_SiteInputs) => LocalizedString) & { parts: (inputs: Platform_Not_Found_SiteInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Platform_Not_Found_SiteInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`Não encontramos uma API para “${i?.apiId}”. Voltar ao catálogo`)
		}),
		{
			parts: /** @type {(inputs: Platform_Not_Found_SiteInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Não encontramos uma API para “" }, { type: "text", value: String(i?.apiId) }, { type: "text", value: "”. " }, { type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "text", value: "Voltar ao catálogo" }, { type: "markup-end", name: "link", options: {}, attributes: {} }])
			})
		}
	)
);

const es_platform_not_found_site = /** @type {((inputs: Platform_Not_Found_SiteInputs) => LocalizedString) & { parts: (inputs: Platform_Not_Found_SiteInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Platform_Not_Found_SiteInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`No encontramos una API para “${i?.apiId}”. Volver al catálogo`)
		}),
		{
			parts: /** @type {(inputs: Platform_Not_Found_SiteInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "No encontramos una API para “" }, { type: "text", value: String(i?.apiId) }, { type: "text", value: "”. " }, { type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "text", value: "Volver al catálogo" }, { type: "markup-end", name: "link", options: {}, attributes: {} }])
			})
		}
	)
);

const fr_platform_not_found_site = /** @type {((inputs: Platform_Not_Found_SiteInputs) => LocalizedString) & { parts: (inputs: Platform_Not_Found_SiteInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Platform_Not_Found_SiteInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`Nous n’avons pas trouvé d’API pour « ${i?.apiId} ». Retour au catalogue`)
		}),
		{
			parts: /** @type {(inputs: Platform_Not_Found_SiteInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Nous n’avons pas trouvé d’API pour « " }, { type: "text", value: String(i?.apiId) }, { type: "text", value: " ». " }, { type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "text", value: "Retour au catalogue" }, { type: "markup-end", name: "link", options: {}, attributes: {} }])
			})
		}
	)
);

const de_platform_not_found_site = /** @type {((inputs: Platform_Not_Found_SiteInputs) => LocalizedString) & { parts: (inputs: Platform_Not_Found_SiteInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Platform_Not_Found_SiteInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`Wir haben keine API für „${i?.apiId}“ gefunden. Zurück zum Katalog`)
		}),
		{
			parts: /** @type {(inputs: Platform_Not_Found_SiteInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Wir haben keine API für „" }, { type: "text", value: String(i?.apiId) }, { type: "text", value: "“ gefunden. " }, { type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "text", value: "Zurück zum Katalog" }, { type: "markup-end", name: "link", options: {}, attributes: {} }])
			})
		}
	)
);

const ru_platform_not_found_site = /** @type {((inputs: Platform_Not_Found_SiteInputs) => LocalizedString) & { parts: (inputs: Platform_Not_Found_SiteInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Platform_Not_Found_SiteInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`Мы не нашли API по запросу «${i?.apiId}». Назад в каталог`)
		}),
		{
			parts: /** @type {(inputs: Platform_Not_Found_SiteInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Мы не нашли API по запросу «" }, { type: "text", value: String(i?.apiId) }, { type: "text", value: "». " }, { type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "text", value: "Назад в каталог" }, { type: "markup-end", name: "link", options: {}, attributes: {} }])
			})
		}
	)
);

const it_platform_not_found_site = /** @type {((inputs: Platform_Not_Found_SiteInputs) => LocalizedString) & { parts: (inputs: Platform_Not_Found_SiteInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Platform_Not_Found_SiteInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`Non abbiamo trovato un'API per «${i?.apiId}». Torna al catalogo`)
		}),
		{
			parts: /** @type {(inputs: Platform_Not_Found_SiteInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Non abbiamo trovato un'API per «" }, { type: "text", value: String(i?.apiId) }, { type: "text", value: "». " }, { type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "text", value: "Torna al catalogo" }, { type: "markup-end", name: "link", options: {}, attributes: {} }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "We couldn’t find an API for “{apiId}”. Back to catalog" |
*
* @param {Platform_Not_Found_SiteInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const platform_not_found_site = /** @type {((inputs: Platform_Not_Found_SiteInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & { parts: (inputs: Platform_Not_Found_SiteInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Platform_Not_Found_SiteInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, { link: { options: {}; attributes: {}; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Platform_Not_Found_SiteInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString} */ ((inputs, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			if (locale === "zh-Hans") return zh_hans1_platform_not_found_site(inputs)
			if (locale === "pt-BR") return pt_br2_platform_not_found_site(inputs)
			if (locale === "es") return es_platform_not_found_site(inputs)
			if (locale === "fr") return fr_platform_not_found_site(inputs)
			if (locale === "de") return de_platform_not_found_site(inputs)
			if (locale === "ru") return ru_platform_not_found_site(inputs)
			if (locale === "it") return it_platform_not_found_site(inputs)
			return en_platform_not_found_site(inputs)
		}),
		{
			parts: /** @type {(inputs: Platform_Not_Found_SiteInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => import('../runtime.js').MessagePart[]} */ ((inputs, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				if (locale === "zh-Hans") return typeof zh_hans1_platform_not_found_site.parts === "function" ? zh_hans1_platform_not_found_site.parts(inputs) : [{ type: "text", value: zh_hans1_platform_not_found_site(inputs) }]
				if (locale === "pt-BR") return typeof pt_br2_platform_not_found_site.parts === "function" ? pt_br2_platform_not_found_site.parts(inputs) : [{ type: "text", value: pt_br2_platform_not_found_site(inputs) }]
				if (locale === "es") return typeof es_platform_not_found_site.parts === "function" ? es_platform_not_found_site.parts(inputs) : [{ type: "text", value: es_platform_not_found_site(inputs) }]
				if (locale === "fr") return typeof fr_platform_not_found_site.parts === "function" ? fr_platform_not_found_site.parts(inputs) : [{ type: "text", value: fr_platform_not_found_site(inputs) }]
				if (locale === "de") return typeof de_platform_not_found_site.parts === "function" ? de_platform_not_found_site.parts(inputs) : [{ type: "text", value: de_platform_not_found_site(inputs) }]
				if (locale === "ru") return typeof ru_platform_not_found_site.parts === "function" ? ru_platform_not_found_site.parts(inputs) : [{ type: "text", value: ru_platform_not_found_site(inputs) }]
				if (locale === "it") return typeof it_platform_not_found_site.parts === "function" ? it_platform_not_found_site.parts(inputs) : [{ type: "text", value: it_platform_not_found_site(inputs) }]
				return typeof en_platform_not_found_site.parts === "function" ? en_platform_not_found_site.parts(inputs) : [{ type: "text", value: en_platform_not_found_site(inputs) }]
			})
		}
	)
);